/**
 * <s-bubble-pop> — pops the bubble X buttons.
 * When any X close button (.ios-close, or anything with data-bubble-pop) is clicked,
 * the button swells and bursts, and iridescent droplets fly out from where it was.
 * The close itself is untouched: the button's own command/click still runs.
 * Rendered once in layout/theme.liquid.
 */
class SBubblePop extends HTMLElement {
  #onClick = (event) => {
    const target = event.target instanceof Element ? event.target.closest('.ios-close, [data-bubble-pop]') : null;
    if (!target || target.classList.contains('is-popping')) return;
    this.#pop(target);
  };

  connectedCallback() {
    document.addEventListener('click', this.#onClick, true);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onClick, true);
  }

  #pop(button) {
    button.classList.add('is-popping');
    window.setTimeout(() => button.classList.remove('is-popping'), 650);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const host = button.offsetParent || button.parentElement;
    if (!host) return;
    const hostRect = host.getBoundingClientRect();
    const rect = button.getBoundingClientRect();
    const burst = document.createElement('span');
    burst.setAttribute('aria-hidden', 'true');
    burst.style.cssText = `position:absolute;pointer-events:none;z-index:10;left:${rect.left - hostRect.left + host.scrollLeft}px;top:${rect.top - hostRect.top + host.scrollTop}px;width:${rect.width}px;height:${rect.height}px;`;

    const colors = ['rgb(255 128 64)', 'rgb(236 72 153)', 'rgb(70 130 255)', 'rgb(150 90 255)', 'rgb(255 255 255)'];
    const count = 10;
    const radius = rect.width * 0.5;
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      const distance = radius + 10 + Math.random() * 14;
      const drop = document.createElement('span');
      drop.className = 'bubble-drop';
      drop.style.setProperty('--drop-x', `${Math.cos(angle) * distance}px`);
      drop.style.setProperty('--drop-y', `${Math.sin(angle) * distance}px`);
      drop.style.setProperty('--drop-size', `${3 + Math.random() * 4}px`);
      drop.style.setProperty('--drop-color', colors[i % colors.length]);
      burst.append(drop);
    }
    host.append(burst);
    window.setTimeout(() => burst.remove(), 600);
  }
}

if (!customElements.get('s-bubble-pop')) customElements.define('s-bubble-pop', SBubblePop);
